import { PATIENT_SERVICES_BASE_URL } from '@src/constants';

export const displayNavigation = (
	pathname: string,
	oneClickLogin: boolean,
	returnTo: string | string[] | undefined
): boolean => {
	return !!(
		!oneClickLogin &&
		pathname !== '/patient-services' &&
		!pathname.includes('expiration') &&
		!pathname.includes('global-error') &&
		!pathname.includes('authentication') &&
		!pathname.includes('patient-information') &&
		pathname.includes(`/${PATIENT_SERVICES_BASE_URL}`) &&
		(!pathname.includes('forms') ||
			pathname.includes('forms/confirmation') ||
			(pathname.includes('forms/insurance') && returnTo))
	);
};
